/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import React, { memo, useState, useEffect } from 'react';
import styles from './ScrollTopWhite.module.less';
import { scrollingDom } from '../../utils/utils';
import defaultImg from '../../static/backTop_white.svg';
import defaultImgHover from '../../static/backTop_white_hover.svg';
import { set } from 'lodash-es';

export default memo(({ node, quickly }) => {
  const [visible, setVisible] = useState(false);
  const [showImg, setShowImg] = useState(defaultImg);

  const handleScroll = () => {
    if (node && node.scrollTop > 1500) {
      setVisible(true);
      return;
    }
    setVisible(false);
  };

  const handleScrollToTop = () => {
    let speed = 80;
    if (node && node.scrollTop > 0) {
      if (node.scrollTop > 1000) {
        speed = parseInt(node.scrollTop / 1000) * 50;
      }
      if (quickly) {
        speed = parseInt(node.scrollTop / 1) * 1;
      }
      scrollingDom(node, 0, speed);
    }
  };

  useEffect(() => {
    node && node.addEventListener('scroll', handleScroll);
    return () => {
      node && node.removeEventListener('scroll', handleScroll);
    };
  }, [node]);
  if (!visible) {
    return <></>;
  }
  return (
    <div
      className={styles.scroll_top_main}
      onClick={handleScrollToTop}
      onMouseEnter={() => setShowImg(defaultImgHover)}
      onMouseLeave={() => setShowImg(defaultImg)}
    >
      <img src={showImg} />
    </div>
  );
});
